export { default } from './OtherQuestions';
